export default "__VITE_ASSET__BzMeWkuZ__"